import {
  TextField,
  Box,
  Typography,
  FormControl,
  Button,
  IconButton,
  Tooltip,
  MenuItem,
  InputLabel,
  Select,
  LinearProgress,
  Paper,
  Stack
} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import { Formik } from "formik";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import {
  getFetchData,
  postData,
  getCheckIn,
} from "../../../store/reducers/Formapireducer";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import React, { useState, useEffect, useRef } from "react";
import { LoadingButton } from "@mui/lab";
import Swal from "sweetalert2";
import { useProSidebar } from "react-pro-sidebar";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import { CheckinAutocomplete } from "../../../ui-components/global/Autocomplete";
import { formGap } from "../../../ui-components/global/utils";
import * as Yup from "yup";
import ChecklistIcon from "@mui/icons-material/Checklist";

import { FaFileExcel, FaFileImport, FaDownload } from "react-icons/fa";



// import ErrorMsgData from "../../Security/validationMsg.json"

// //import ChecklistRtlIcon from '@mui/icons-material/ChecklistRtl';
// const validationSchema = Yup.object().shape({
//   location: Yup.object().required(ErrorMsgData.CheckIn.location).nullable(),
//   gate: Yup.object().required(ErrorMsgData.CheckIn.gate).nullable(),
//   date: Yup.string().required(ErrorMsgData.CheckIn.date),
//   checkintype: Yup.string().required(ErrorMsgData.CheckIn.checkintype),
//   checkintime: Yup.string().required(ErrorMsgData.CheckIn.checkintime),
//   comment: Yup.string().required(ErrorMsgData.CheckIn.comment),
// });
const Editcheckin = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  let params = useParams();
  const dispatch = useDispatch();
  var recID = params.id;
  var mode = params.Mode;
  var accessID = params.accessID;
  const data = useSelector((state) => state.formApi.Data);
  const Status = useSelector((state) => state.formApi.Status);
  const Msg = useSelector((state) => state.formApi.msg);
  const isLoading = useSelector((state) => state.formApi.postLoading);
  const getLoading = useSelector((state) => state.formApi.getLoading);
  const checkInOutData = useSelector((state) => state.formApi.checkInOutData);
  const listViewurl = useSelector((state) => state.globalurl.listViewurl);
  const EMPID = sessionStorage.getItem("EmpId");
  const Locname = sessionStorage.getItem("Locname");
  const Locid = sessionStorage.getItem("Locid");
  const Gateid = sessionStorage.getItem("Gateid");
  const Gatename = sessionStorage.getItem("Gatename");
  console.log(Locname, Locid, Gateid, Gatename, "sessions");
  const CompId = sessionStorage.getItem("companyId");
  const { toggleSidebar, broken, rtl } = useProSidebar();
  const location = useLocation();
  const rowData = location.state || {};



  const SubscriptionCode = sessionStorage.getItem("SubscriptionCode");
  const is003Subscription = SubscriptionCode.endsWith("003");
  console.log(SubscriptionCode, is003Subscription, "SubscriptionCode");


  useEffect(() => {
    dispatch(getFetchData({ accessID, get: "get", recID }));
  }, [location.key]);

  // *************** INITIALVALUE  *************** //

  const getCurrentTime = () => {
    const now = new Date();
    const hours = now.getHours().toString().padStart(2, "0");
    const minutes = now.getMinutes().toString().padStart(2, "0");
    return `${hours}:${minutes}`; // "HH:mm"
  };

  function getLocalDate() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const date = String(now.getDate()).padStart(2, "0");
    return `${year}-${month}-${date}`;
  }

  const [time, setTime] = useState(getCurrentTime());
  const [currentData, setCurrentData] = useState(getLocalDate());
  const [errorMsgData, setErrorMsgData] = useState(null);
  const [validationSchema, setValidationSchema] = useState(null);

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/validationcms.json")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch validationcms.json");
        return res.json();
      })
      .then((data) => {
        setErrorMsgData(data);
        const schema = Yup.object().shape({
          location: Yup.object().required(data.CheckIn.location).nullable(),
          gate: Yup.object().required(data.CheckIn.gate).nullable(),
          date: Yup.string().required(data.CheckIn.date),
          checkintype: Yup.string().required(data.CheckIn.checkintype),
          checkintime: Yup.string().required(data.CheckIn.checkintime),
          comment: Yup.string().trim().required(data.CheckIn.comment),
        });

        setValidationSchema(schema);
      })
      .catch((err) => console.error("Error loading validationcms.json:", err));
  }, []);


  useEffect(() => {
    if (mode == "A") {
      const interval = setInterval(() => {
        const now = new Date();

        const today = getLocalDate();
        if (today !== currentData) {
          setCurrentData(getLocalDate());
        }
        setTime(getCurrentTime());

      }, 1000); // update every second

      return () => clearInterval(interval); // cleanup on unmount
    }

  }, []);


  const InitialValue = {
    checkintype: mode == "A" ? "R" : data.CheckInType,
    date: mode == "A" ? currentData : data.HiddenDate,
    comment: data.CheckInComment,
    checkintime: mode == "A" ? time : data.CheckInTime,
    disable: data.WorkAtHome === "Y" ? true : false,
    location: data.LocationRecID
      ? { RecordID: data.LocationRecID, Name: data.LocationName }
      : { RecordID: Locid, Name: Locname },

    gate: data.GateRecID
      ? { RecordID: data.GateRecID, Name: data.GateName }
      : { RecordID: Gateid, Name: Gatename }
  };

  const Fnsave = async (values) => {
    let action = mode === "A" ? "insert" : "update";
    var isCheck = "N";
    if (values.disable == true) {
      isCheck = "Y";
    }

    const idata = {
      RecordID: recID,
      CheckInType: mode == "E" || mode == "A" ? "R" : values.checkintype,
      // CheckInType: values.checkintype,
      CheckInDate: values.date,
      CheckInComment: values.comment,
      EmployeeID: EMPID,
      WorkAtHome: isCheck,
      LocationRecID: values.location.RecordID || 0,
      LocationName: values.location.Name || "",
      GateRecID: values.gate.RecordID || 0,
      GateName: values.gate.Name || "",
      CheckInTime: values.checkintime,
      Source: "Cloud",
    };
    const response = await dispatch(postData({ accessID, action, idata }));
    console.log(response);
    if (response.payload.Status == "Y") {
      toast.success(response.payload.Msg);
      navigate("/Apps/TR123/Check In");
    } else if (response.payload.Status == "N") {
      toast.error(response.payload.Msg);
    } else {
      toast.error(response.payload.Message);
    }
  };

  const fnLogOut = (props) => {
    Swal.fire({
      // title: `Do you want ${props}?`,
      title: errorMsgData.Warningmsg[props],
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: props,
    }).then((result) => {
      if (result.isConfirmed) {
        if (props === "Logout") {
          navigate("/");
        }
        if (props === "Close") {
          navigate("/Apps/TR123/Check In");
        }
      } else {
        return;
      }
    });
  };

  //bulk upload process
  const fileInputRef = useRef(null);

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.name.match(/\.(xlsx|xls)$/)) {
      alert("Only Excel files allowed");
      return;
    }

    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    const day = today.getDate();

    const dateKey = `${year}${month}${day}`;

    // let counter = localStorage.getItem(dateKey);
    // counter = counter ? parseInt(counter) + 1 : 1;

    // Save updated counter
    // localStorage.setItem(dateKey);

    //  localStorage.removeItem(dateKey);

    // Final filename
    const fileName = `Attendance_Bulk_${dateKey}`;

    console.log(fileName);

    try {
      const formData = new FormData();

      // Match API keys exactly
      formData.append("excel_file", file);
      formData.append("Type", "bulk_process");
      formData.append("file_name", fileName);
       formData.append("SubType", "N");    

      console.log("Sending Data:", {
        excel_file: file.name,
        Type: "bulk_process",
        file_name: fileName,
        SubType: "N",
      });

      const response = await fetch(
        "https://essuat.beyondexs.com/api/BulkAttendanceProcess/Attendance_Bulk_Processor.php",
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await response.json();

      console.log("API Response:", result);

      if (result?.Status === "Y") {
        // localStorage.setItem(dateKey);
        alert("Attendance uploaded successfully ");
      } else {
        alert(result?.message || "Upload failed");
      }

    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong ");
    }

    // Reset input (important)
    e.target.value = null;
  };

  //For Download Process
   const handleDownload = async () => {
    try {
      const response = await fetch(
        "https://essuat.beyondexs.com/api/BulkAttendanceProcess/ExcelFileDownload.php?file=Attendance_Bulk.xlsx",
        {
          method: "GET",
        }
      );

      if (!response.ok) {
        throw new Error("Failed to download file");
      }

      //  Convert response to blob
      const blob = await response.blob();

      //  Create a download URL
      const url = window.URL.createObjectURL(blob);

      //  Create temporary link
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Attendance_Bulk.xlsx"); // file name

      document.body.appendChild(link);
      link.click();

      // ✅ Cleanup
      link.remove();
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error("Download error:", error);
      alert("Failed to download file");
    }
  };


  return (
    <React.Fragment>
      {getLoading ? <LinearProgress /> : false}
      <Paper elevation={3} sx={{ margin: "0px 10px", background: "#fcfcfc", height: "40px" }}>
        <Box display="flex" justifyContent="space-between" >
          <Box display="flex" borderRadius="3px" alignItems="center">
            {broken && !rtl && (
              <IconButton onClick={() => toggleSidebar()}>
                <MenuOutlinedIcon />
              </IconButton>
            )}
            <Typography
              variant="h3"
              sx={{
                marginLeft: "10px", fontSize: "19px",color: "#0000D1" 
              }}
            >
              {/* {mode === "E"
                ? `Check In(${rowData.EmpDTName})`
                : "Check In(New)"} */}
                 {mode === "E"
    ? (is003Subscription
        ? `In Time(${rowData.EmpDTName})`
        : `Check In(${rowData.EmpDTName})`)
    : (is003Subscription
        ? "In Time(New)"
        : "Check In(New)")}
            </Typography>
          </Box>


          <Box display="flex">
            <Stack
              padding={1}
            >
              <FaFileImport
                size={20}
                title="Import"
                color="#58ac7c"
                style={{ cursor: "pointer" }}
                onClick={() => fileInputRef.current.click()}
              />

              <input
                type="file"
                accept=".xlsx,.xls"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={(e) => handleFileUpload(e)}
              />
            </Stack>

            <Stack
              padding={1}>
              <FaDownload
                size={20}
                title="download"
                cursor='pointer'
                color="#549671"
                onClick={handleDownload} />
            </Stack>

            <Tooltip title="Check In "> 
              <IconButton
                onClick={() => navigate("/Apps/TR123/Check%20In")}
                color="primary"
              >
                <ChecklistIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Close">
              <IconButton onClick={() => fnLogOut("Close")} color="error">
                <ResetTvIcon />
              </IconButton>
            </Tooltip>

            <Tooltip title="Logout">
              <IconButton onClick={() => fnLogOut("Logout")} color="error">
                <LogoutOutlinedIcon />
              </IconButton>
            </Tooltip>

          </Box>
        </Box>
      </Paper>
      {!getLoading ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
          <Formik
            enableReinitialize={true}
            initialValues={InitialValue}
            onSubmit={(values, setSubmitting) => {
              setTimeout(() => {
                Fnsave(values);
              }, 100);
            }}
            validationSchema={validationSchema}
          >
            {({
              errors,
              touched,
              handleBlur,
              handleChange,
              isSubmitting,
              values,
              handleSubmit,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <Box
                  display="grid"
                  gridTemplateColumns="repeat(4 , minMax(0,1fr))"
                  gap={formGap}
                  padding={1}
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 4",
                    },
                  }}
                >
                  <FormControl
                    sx={{
                      gridColumn: "span 2",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <CheckinAutocomplete
                      name="location"
                      label={
                        <>
                          Location<span style={{ color: "red", fontSize: "20px" }}> * </span>
                        </>
                      }
                      id="location"
                      value={values.location}
                      onChange={(newValue) => {
                        setFieldValue("location", newValue);
                      }}
                      url={`${listViewurl}?data={"Query":{"AccessID":"2051","ScreenName":"Location","Filter":"parentID=${CompId}","Any":""}}`}
                      error={!!touched.location && !!errors.location}
                      helperText={touched.location && errors.location}
                    />
                  </FormControl>

                  <FormControl
                    sx={{
                      gridColumn: "span 2",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <CheckinAutocomplete
                      name="gate"
                      label={
                        <>
                          Gate<span style={{ color: "red", fontSize: "20px" }}> * </span>
                        </>
                      }
                      id="gate"
                      value={values.gate}
                      onChange={(newValue) => {
                        setFieldValue("gate", newValue);
                      }}
                      error={!!touched.gate && !!errors.gate}
                      helperText={touched.gate && errors.gate}
                      url={`${listViewurl}?data={"Query":{"AccessID":"2050","ScreenName":"Gate","Filter":"parentID=${values?.location?.RecordID}","Any":""}}`}
                    />
                  </FormControl>
                  <TextField
                    name="date"
                    type="date"
                    id="date"
                    label="Check In Date"
                    variant="standard"
                    focused
                    // required
                    disabled
                    inputFormat="YYYY-MM-DD"
                    value={values.date}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.date && !!errors.date}
                    helperText={touched.date && errors.date}
                    sx={{ gridColumn: "span 2" }}
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ max: new Date().toISOString().split("T")[0] }}
                  />



                  <TextField
                    name="checkintime"
                    type="time"
                    id="checkintime"
                    label="Check In Time"
                    variant="standard"
                    value={values.checkintime}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    focused
                    // required
                    sx={{ gridColumn: "span 2" }}
                    inputProps={{ step: 60 }}
                    disabled
                    error={!!touched.checkintime && !!errors.checkintime}
                    helperText={touched.checkintime && errors.checkintime}
                  />

                  {/* <FormControl
                    focused
                    variant="standard"
                    sx={{ gridColumn: "span 2" }}
                  >
                    <InputLabel id="status">Type</InputLabel>
                    <Select
                      labelId="demo-simple-select-filled-label"
                      id="checkintype"
                      name="checkintype"
                      value={
                        mode == "E" || mode == "A" ? "R" : values.checkintype
                      }
                      // value={values.checkintype}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={!!touched.checkintype && !!errors.checkintype}
                      helperText={touched.checkintype && errors.checkintype}
                      inputProps={{ readOnly: true }}
                    >
                      <MenuItem value="R">Regular</MenuItem>
                      <MenuItem value="L">Late</MenuItem>
                      <MenuItem value="P">Permission</MenuItem>
                      <MenuItem value="O">Onduty</MenuItem>
                      <MenuItem value="V">Leave</MenuItem>
                    </Select>
                  </FormControl> */}
                  <TextField
                    focused
                    variant="standard"
                    label="Type"
                    name="checkintype"
                    value={
                      mode === "E" || mode === "A" ? "Regular" :
                        values.checkintype
                    }
                    onBlur={handleBlur}
                    error={!!touched.checkintype && !!errors.checkintype}
                    helperText={touched.checkintype && errors.checkintype}
                    InputProps={{
                      readOnly: true
                    }}

                    onInvalid={(e) => {
                      e.target.setCustomValidity("Please fill the Check In Type");
                    }}
                    sx={{ gridColumn: "span 2" }}
                  />


                  <TextField
                    name="comment"
                    type="text"
                    id="comment"
                    label={
                      <>
                        Check In Comment<span style={{ color: "red", fontSize: "20px" }}> * </span>
                      </>
                    }
                    variant="standard"
                    focused
                    value={values.comment}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.comment && !!errors.comment}
                    helperText={touched.comment && errors.comment}
                    sx={{ gridColumn: "span 2" }}
                  />
                </Box>
                <Box
                  display="flex"
                  justifyContent="end"
                  mt="20px"
                  gap="20px"
                  padding={1}
                >
                  <LoadingButton
                    color="secondary"
                    variant="contained"
                    type="submit"
                    loading={isLoading}
                  >
                    Save
                  </LoadingButton>

                  <Button
                    color="warning"
                    variant="contained"
                    onClick={() => {
                      navigate("/Apps/TR123/Check In");
                    }}
                  >
                    Cancel
                  </Button>
                </Box>
              </form>
            )}
          </Formik>
        </Paper>
      ) : (
        false
      )}
    </React.Fragment>
  );
};

export default Editcheckin;
